import { useEffect } from 'react';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Tells the server which private chat thread is open (suppresses message push/inbox).
 */
export function useChatPresence(uid, activeFriendId) {
  useEffect(() => {
    if (!uid) return undefined;

    const ref = doc(db, 'users', uid);
    const payload = activeFriendId
      ? { activePrivateChatFriendId: activeFriendId, activePrivateChatUpdatedAt: serverTimestamp() }
      : { activePrivateChatFriendId: null, activePrivateChatUpdatedAt: serverTimestamp() };

    setDoc(ref, payload, { merge: true }).catch((err) => {
      console.warn('useChatPresence:', err?.message || err);
    });

    return () => {
      setDoc(
        ref,
        { activePrivateChatFriendId: null, activePrivateChatUpdatedAt: serverTimestamp() },
        { merge: true }
      ).catch(() => {});
    };
  }, [uid, activeFriendId]);
}
